<template>
  <div class="relative langPosition">
    <button
      href="#"
      class="flex items-center langDropdownButton"
      @click="toggleVisibility"
      @keydown.space.exact.prevent="toggleVisibility"
      @keydown.esc.exact="hideDropdown"
      @keydown.shift.tab="hideDropdown"
      @keydown.up.exact.prevent="startArrowKeys"
      @keydown.down.exact.prevent="startArrowKeys"
    >
      <img :src="`/flag_${$i18n.locale}.svg`" alt="flag" class="flag" />
      <!--
      <span class="ml-2 font-weight-bold shortName">{{ $i18n.locale.toUpperCase() }}</span>
      -->
    </button>
    <transition name="dropdown-fade">
      <ul
        v-on-clickaway="hideDropdown"
        v-if="isVisible"
        ref="dropdown"
        class="position-absolute normal-case font-normal text-left shadow overflow-hidden mt-2 py-1"
      >
        <li v-for="(lang, idx) in langs" :key="idx" class="py-2">
          <a
            href="#"
            @click.prevent="setLocale(lang.shortName)"
            class="flex py-3 langHover"
            @keydown.up.exact.prevent
            @keydown.tab.exact="focusNext(false)"
            @keydown.down.exact.prevent="focusNext(true)"
            @keydown.esc.exact="hideDropdown"
          >
            <img :src="lang.flag" :alt="lang.longName" class="flag" />
            <span class="ml-2">{{ lang.localName }}</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],
  data() {
    return {
      isVisible: false,
      focusedIndex: 0,
      langs: [
        {
          shortName: "en",
          longName: "English",
          localName: "English",
          flag: "/flag_en.svg"
        },
        {
          shortName: "ko",
          longName: "Korean",
          localName: "한국어",
          flag: "/flag_ko.svg"
        },
        {
          shortName: "ja",
          longName: "Japanese",
          localName: "日本語",
          flag: "/flag_ja.svg"
        },
        {
          shortName: "zh",
          longName: "Chinese",
          localName: "中文",
          flag: "/flag_zh.svg"
        },
        {
          shortName: "de",
          longName: "German",
          localName: "Deutsch",
          flag: "/flag_de.svg"
        },
        {
          shortName: "fr",
          longName: "French",
          localName: "Français",
          flag: "/flag_fr.svg"
        },
        {
          shortName: "es",
          longName: "Spanish",
          localName: "Español",
          flag: "/flag_es.svg"
        },
        {
          shortName: "it",
          longName: "Italian",
          localName: "Italiano",
          flag: "/flag_it.svg"
        },
        {
          shortName: "ru",
          longName: "Russian",
          localName: "русский",
          flag: "/flag_ru.svg"
        }
      ]
    };
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
    hideDropdown() {
      this.isVisible = false;
      this.focusedIndex = 0;
    },
    startArrowKeys() {
      if (this.isVisible) {
        // this.$refs.account.focus()
        this.$refs.dropdown.children[0].children[0].focus();
      }
    },
    focusPrevious(isArrowKey) {
      this.focusedIndex = this.focusedIndex - 1;
      if (isArrowKey) {
        this.focusItem();
      }
    },
    focusNext(isArrowKey) {
      this.focusedIndex = this.focusedIndex + 1;
      if (isArrowKey) {
        this.focusItem();
      }
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus();
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale }
      });
      this.hideDropdown();
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.1s ease-in-out;
}
.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

.langPosition {
  margin-right: 24px;
  margin-top: 24px;
}

.langDropdownButton {
  cursor: pointer !important;
  background-color: transparent !important;
  border: none;
  padding-right: 0px;
}

.shortName {
  margin-top: 5px !important;
}

ul {
  text-align: left;
  min-width: 138px;
  border-radius: 8px;
  background: white;
  z-index: 500;
  position: absolute;
  list-style: none;
  padding: 10px 0px !important;
  margin: 0px !important;
  top: 80px;
  right: 106px;
}

.flag {
  width: 30px;
}

.langHover {
  right: 20px;
  margin: 25px;
  text-decoration: none;
  color: #222;
  transition: all 0.1s ease-in-out;
  &:hover {
    color: #00e156;
  }
}

@media (max-width: 621px) {
  ul {
    top: 70px;
    right: 96px;
  }
}
</style>
